// import HighRiskDataMock from "./highRiskMock";

const initialState = {
  isLoading: false,
  isBtnLoading: false,
  isProcessing: false,
  currentPage: "signIn",
  errorPageError: null,
  applicationConfirmed: false,
  step: null,
  merchantId: "",
  subMerchantId: "",
  clientId: "",
  sessionToken: "",
  kycToken: "",
  pToken: "",
  prerequisites: null,
  piiData: null,
  applicationId: "",
  customerId: "",
  dashboardUrl: "",
  lToken: "",
  embedded: null,
  banks: null,
  highRisk: null, // HighRiskDataMock,
  enableHighRiskQuestionnaire: true,
  skipInitiationAgreement: null,
  stepDefinition: null,
  dialog: {
    dialogTitle: "",
    dialogContent: "",
    trimQuote: true,
  },
  isDialogShow: false,
  isALDialogShow: false,
  eligibilityAmount: null,
  applicationStatus: "",
  requireConsentFlag: false,
  isRepaymentMethodV2Enable: false,
  isBoostJourney: false,
  isOnboardingUpdate: false,
  experian: null, // { downtimeFlag, startTime, endTime, displayType } — see EXPERIAN_DISPLAY_TYPE in constants/experian.js
};

export default initialState;
